import React from "react";

const FormGroup = ({ children, className = "" }) => {
	return <div className={`form-group ${className}`}>{children}</div>;
};

export default FormGroup;
